import { css } from 'styled-components';
import BREAKPOINTS from '../constants/breakpoints.js';
const MEDIA = Object.keys(BREAKPOINTS).reduce((acc, label) => {
  acc[label] = (...args) => css(["@media (max-width:", "em){", ";}"], BREAKPOINTS[label] / 16, css(...args));
  acc[`MIN_${label}`] = (...args) => css(["@media (min-width:", "em){", ";}"], BREAKPOINTS[label] / 16, css(...args));
  return acc;
}, {});
export default MEDIA;